export default {
  en: {
    noCommunityData: 'No community data available',
    password: 'Password',
    verifyPassword: 'Verify password',
    passwordsDontMatch: "Passwords don't match",
    userName: 'Username (e-mail)',
    language: 'Language',
    fullName: 'Full name',
    next: 'Next',
    nameRequired: 'Please enter a name',
    cityRequired: 'Please enter a city',
    descriptionRequired: 'Please enter a description',
    selectCountry: 'Please select a country',
    name: 'Name',
    city: 'City',
    postalCode: 'Postal code',
    streetAndNumber: 'Street and number',
    country: 'Country',
    createUser: 'Create user',
    signLegalDocuments: 'Agree with Terms of Use',
    suggestionsRequired: 'Please select an organisation',
    streetAndNumberRequired: 'Street and number are required',
    postalCodeRequired: 'Postal code is required',
    suggestions: 'Suggestions',
    selectPlaceholder: 'Select...',
    createAnAccount: 'Create an account',
    loginToYourAccount: 'Login to your account',
    join: 'Join',
    joinOrganisationOnPlatform: 'Join an organisation already on the platform',
    register: 'Register',
    registerOrganisationOnPlatform: 'Register an organisation new to the platform',
    confirmationEmailSent: 'Check your e-mail',
    resendEmail: 'Resend e-mail',
    confirmationEmailContent:
      "An e-mail has been sent to {{email}}.\n\nPlease open your e-mail and click the validation link to proceed with your registration. If you can't find an e-mail, check your SPAM or resend the e-mail with the button below.\n\nThis window can be closed.",
    passwordRequired: 'Please enter a password',
    passwordMinimum12charactersErr: 'A password needs to be minimum 12 characters',
    passwordMaximum80charactersErr: 'A password can be maximum 80 characters',
    reEnterPassword: 'Please re-enter your password',
    joinRequestSent: 'Join request sent',
    joinRequestContent:
      'Please wait for the organisation admin to accept your join request. Contact your organisation manager/admin for further follow-up.',
    readAllLegalDocuments: 'I have read and agree with above documents',
    sign: 'Agree',
    welcome: 'Welcome',
    chooseRoles: 'Choose roles',
    login: 'Sign in',
    communityMembershipTemplateGetFailed:
      'Something went wrong, could not get community membership template',
    membershipAlreadyRequested: 'Membership already requested',
    noLegalDocumentsToSign: 'No documents to agree',
    welcomeToTheCommunity: 'Welcome to the community.',
    viewApps: 'View apps',
    membershipRequestFailed: 'Oops, request to join community failed',
    error: 'Error',
    chooseSuggestedOrganisationToJoin:
      'Based on your e-mail address you might want to join one of the following existing organisations.',
    joinSuggestedOrganisation:
      'Based on your e-mail adress you might want to join this existing organisation.',
    selectAnOrganisation: 'Please select an organisation',
    organisationName: 'Organisation name',
    back: 'Back',
    addIdentificationCode: 'Add identification code',
    identificationCode: 'Identification code',
    welcomeMessageTitle: 'Welcome to the platform!',
    selectLanguage: 'Please select a language',
    selectTimezone: 'please select a timezone',
    type: 'Type',
    organisationNameAlreadyExists: 'Organisation name already exists',
    errorWhileValidatingOrganisationName:
      'Oops, an error occured while validating the organisation name',
    thisIdentificationCodeIsAlreadyInUse: 'This identification code is already in use',
    errorWhileIdentificationCodeName:
      'Oops, an error occured while validating the identification code',
    continue: 'Continue',
    invalidEmailErr: 'Please enter a valid email address',
    dear: 'Dear {{user}},',
    successfullyReceivedRegistration:
      ' We have successfully received your registration. You will soon receive an email with a link that will give you access to the application(s) you have registered for.',
    furtherQuestions:
      'Should you have any further questions, please contact your community administrator.',
    'sorry!': 'Sorry!',
    pageRequestedNotFound: 'The page you requested was not found.',
    toTheCommunityPortal: 'To the nallian portal.',
    validateUsernameFailed: 'Error while validation the username',

    /* user mgmt + request membership */
    myOrganisation: 'My organisation',
    noMembershipRequests: 'No membership requests present',
    membershipRequests: 'Membership requests',
    createdOn: 'Created on',
    areYouSureYouWantToDenyUser: 'Are you sure you want to deny access to this user?',
    cancel: 'Cancel',
    deny: 'Deny',
    requestOfOrganisation: 'Request of {{organisation}}',
    applications: 'Applications',
    roles: 'Roles',
    signedLegalDocuments: 'Agreed legal documents',
    accept: 'Accept',
    membershipRequestUpdateFailed: 'Oops, could not update membership request',
    membershipRequestUpdateSuccess: 'Membership request updated',
    areYouSureYouWantToendMembership: 'Are you sure you want to end the membership?',
    overview: 'Overview',
    eMailaddress: 'Email address (professional)',
    membershipRequestAccepted: 'Membership request accepted',
    membershipRequestDenied: 'Membership request denied',
    dashboard: 'Dashboard',
    getLanguagesErr: 'Oops, could not fetch languages',
    getAuthorizationRolesErr: 'Oops, could not fetch authorization roles',
    getTimezonesErr: 'Oops, could not fetch timezones',
    getOrganisationStatsErr: 'Oops, could not fetch statistics',
    users: 'Users',
    noUserPresent: 'No users present',
    state: 'State',
    editUser: 'Edit user',
    deleteUser: 'Remove user',
    areYouSureYouWantToDeleteUser: 'Do you want to remove {{userName}}?',
    inviteNewUser: 'Invite new user',
    save: 'Save',
    invite: 'Invite',
    inviteUserSendEmailToAddress: 'Invite user, send email to following address:',
    createUserWithPassword: 'Create user with password:',
    enterPassword: 'Enter password',
    forceUserToChooseNewPassword: 'Force user to choose a new password on first login',
    pleaseEnterEmailAddress: 'Please enter a valid emailaddress',
    pleaseEnterRecipient: 'Please enter a recipient',
    pleaseEnterPassword: 'Please enter a password',
    selectRole: 'Please select at least one role.',
    usernameTaken: 'This username is already taken',
    userUpdated: 'User updated',
    inviteUserFailed: 'Oops, could not invite user',
    inviteUser: 'Invite user',
    userInvited: 'User invited',
    userDeleted: 'User deleted',
    deleteUserFailed: 'Oops, could not delete user',
    delete: 'Delete',
    noOrganisationRegistrations: 'No organisation registrations',
    trustedDomains: 'Trusted domain',
    trustedDomains_plural: 'Trusted domains',
    trustedDomainsOverview: 'Trusted domains',
    createTrustedDomainSuccess: 'Trusted domain is created',
    createTrustedDomainFailed: 'Something went wrong, could not create trusted domain',
    updateTrustedDomainSuccess: 'Updated trusted domain',
    addTrustedDomain: 'Add trusted domain',
    updateTrustedDomainFailed: 'Something went wrong, could not update trusted domain',
    domain: 'Domain',
    domainEmptyErr: 'Please enter an domain',
    domainInvalidErr: 'Please check the domain name.',
    autoJoin: 'Auto-join',

    /* community mgmt */
    remove: 'Remove',
    organisation: 'Organisation',
    areYouSureYouWantToDenyOrganisation:
      'Are you sure you want to deny access to this organisation?',
    areYouSureYouWantToRemoveTheRequest: 'Are you sure you want to remove the request?',
    myCommunity: 'My community',
    noMembersPresent: 'No members present.',
    addMember: 'Add member',
    edit: 'Edit',
    endMembership: 'Cancel membership',
    editMembership: 'Edit membership',
    areYouSureYouWantToEndMembership:
      'Are you sure you want to end the membership of {{organisationName}}?',
    communityMembershipEnded: 'Community membership ended',
    endCommunityMembershipFailed: 'Something went wrong, could not end membership',
    communityMembershipUpdate: 'Updated community membership',
    updateCommunityMembershipFailed: 'Something went wrong, could not update community membership',
    getCommunityMembershipFailed: 'Something went wrong, could not retrieve community membership',
    communityMembershipCreated: 'Community member created',
    createCommunityMembershipFailed: 'Something went wrong, could not create community member',
    addACommunityMember: 'Add a community member',
    updateMembershipOf: 'Update membership {{organisationName}}',
    members: 'Members',
    getUserStatesErr: 'Something went wrong, could not get userstates',
    rejectionNotice: 'Rejection notice',
    addApp: 'Add app',
    app: 'App',
    actions: 'Actions',
    role: 'Role',
    registerError: 'Something went wrong during the registration.',
    contactAdministrator:
      'For more information on the use of this Nallian Portal, please contact your Community Administrator.',
    registerEmailDomainAsTrustedRequired: 'You must enable or disable this field.',
    proceed: 'Proceed',
    privateCommunityTitle: 'Private community',
    privateCommunityDescription: 'This is a private community which can not be joined.',

    pleaseSelectOrganisation: 'Please select an organisation',
    pleaseSelectMinimumOneRole: 'Please select minimum one role',
    none: 'None',
    membershipRequestGetFailed: 'Something went wrong, could not get membership request',
    getCommunityStatsErr: 'Something went wrong, could not get community stats',
    communityMember: 'Community member',
    registrationGetFailed: 'Something went wrong, could not get registration',
    getTrustedDomainFailed: 'Something went wrong, could not get trusted domain',
    pleaseEnterAnEmailAddress: 'Please enter an e-mail address',
    noUsersPresent: 'No users present',
    communities: 'Communities',
    home: 'Home',
    getIdentificationCodeTypesFailed:
      'Something went wrong, failed to get identification code types',
    pleaseSelectAType: 'Please select a type',
    pleaseEnterAValue: 'Please enter a value',
    disabled: 'Disabled',
    unverified: 'Unverified',
    verified: 'Verified',
    userState: 'User state',
    couldNotGetCommunityTemplate:
      'Something went wrong, could not retrieve the community description',
    getTermsAndConditionsFailed:
      'Something went wrong, could not retrieve the Terms and Conditions',
    chooseAPassword: 'Choose a password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    userAccountReady: 'User account ready!',
    passwordResetSuccess:
      'Your password has been successfully reset. You can now sign in to your apps.',
    failedContactOur: 'Failed to reset password, please contact our',
    support: 'Support',
    department: 'department',
    pleaseConfirmUserAccount: 'Please confirm this is your user-account',
    confirm: 'Confirm',
    invalidToken: 'Invalid token',
    needTechnicalSupport: 'If you need technical assistance , please contact our',
    passwordMin8Char: 'Choose a password of minimum 8 charaters',
    passwordConfirmIncorrect: 'Confirmation of password is incorrect',
    pleaseEnterValidEmail: 'Please enter a valid emailaddress',
    forgotPassword: 'Forgot password',
    requestNewPassword: 'Request new password',
    resetPasswordRequested: 'Reset password requested!',
    resetPasswordRequestText:
      'If you are a registered user an e-mail has been sent to your mailbox to reset your password. Please click the link in this e-mail to proceed. You can now close this window.',
    somethingWentWrong: 'Something went wrong',
    pleaseContactOur: 'Please contact our',
    failedResentEmail: 'Failed to resend invitation e-mail',
    resentEmailSuccess: 'Invitation e-mail has been resent',
    ohNo: 'Oh no!',
    invitationExpired: 'Your invitation is expired. Let us send you a new invitation:',
    resentInvitationEmail: 'Resend invitation e-mail',
    thanksForSubscribing: 'Thank you for subscribing and welcome to the Platform!',
    activatedBasicAccount:
      'We have activated your basic account which will allow you to access the various applications available to your account.',
    accessApplications:
      'You will be able to access the applications as soon as we have received the related signed agreement form(s).',
    beAware:
      'Please be aware that a Go - Live date at a later time might be applicable for certain applications.',
    contactUs: 'Contact us',
    ifQuestions: 'in case of any questions.',
    failedToActivateUserAccount: 'Failed to activate user account',
    goodNews: 'Good news!',
    accountAlreadyActivated:
      'Your account is already activated. Please go to the app using the direct link as provided in the App instructions.',
    invalidTokenText:
      'Your activation token is invalid, make sure to use the activation link in the last received invitation e-mail. If you did not receive this e-mail (do not forget your spam!), you can always contact our',
    passwordInvalidErr: 'Please enter a valid password',
    inviteSuccessMessage:
      'Your user account has been successfully registered on the Nallian platform. To continue and start using the applications, please click "Proceed" to login to the Nallian Portal.',
    address: 'Address',
    getOrganisationIdentificationCodesFailed:
      'Failed to retrieve organisation identification codes',
    getOrganisationFailed: 'Failed to retrieve organisation info',
    identificationCodes: 'Identification codes',
    getOrganisationAddressFailed: 'Failed to retrieve organisation address',
    membershipOf: 'Membership of {{organisation}}',
    organisationInfo: 'Organisation info',
    noRolesFound: 'No roles found',
    noAppsFound: 'No apps found',
    organisationUsers: 'User',
    userReinvited: 'User re-invited',
    userReinviteFailed: 'Could not re-invite user',
    reinviteUser: 'Reinvite user',
    areYouSureReinvite: 'Are you sure you want to re-invite {{userName}}?',
    yes: 'Yes',
    no: 'No',
    dontHaveAnAccountYet: "Don't have an account yet?",
    registerHere: 'Register here!',
    inviteInfo:
      'Someone from your organisation has invited you to join the platform. Please confirm that the details that are shown below are yours.',
    chooseAPasswordInfo: 'Please choose a password to finalize the invitation process.',
    resetYourPassword: 'Reset your password',
    createAnotherUser: 'Create another user',
    createdBy: 'Created by',
    createCommunityMember: 'Create community member',
    isTest: 'Is test',
    isDefault: 'Is default',
    isMessageCode: 'Is message code',
    code: 'Code',
    codeValue: 'Code',
    description: 'Description',
    updateIdentificationCodeFailed: 'Update identification code failed',
    updateIdentificationCodeSuccess: 'Update identification code success',
    addIdentificationCodeFailed: 'Add identification code failed',
    addIdentificationCodeSuccess: 'Add identification code success',
    getIdentificationCodeFailed: 'Get identification code failed',
    identificationCodeType: 'Identification code type',
    removeIdentificationCode: 'Remove identification code',
    add: 'Add',
    editIdentificationCode: 'Edit identification code',
    viewIdentificationCode: 'View identification code',
    routings: 'Routings',
    order: 'Order',
    regex: 'Regex',
    emailAddresses: 'E-mail addresses',
    toZendesk: 'To Zendesk',
    enabled: 'Enabled',
    editRouting: 'Edit routing',
    addRouting: 'Add routing',
    removeRouting: 'Are you sure you want to remove this routing?',
    toVoid: 'To void',
    addAttachments: 'Add attachments',
    stopProcessing: 'Stop processing',
    zendeskTags: 'Zendesk tags',
    priority: 'Priority',
    mustFillInEmailNoZendeskAndNoVoid:
      'You must fill in an e-mail if To Void or To Zendesk is not enabled',
    nameEmptyErr: 'Please fill in a name',
    orderEmptyErr: 'Please fill in an order',
    regexEmptyErr: 'Please fill in a regex',
    priorityIdEmptyErr: 'Please select a priority',
    routingsOrder: 'Routings order',
    updateRoutingsOrderSuccess: 'Update routings order success',
    updateRoutingsOrderFailed: 'Update routings order failed',
    saveOrder: 'Save order',
    apiResources: 'Api resource',
    apiResources_plural: 'Api resources',
    tokenLifetime: 'Token lifetime',
    stsclients: 'STS Client',
    stsclients_plural: 'STS Clients',
    clientName: 'Client name',
    clientId: 'Client ID',
    fillForm: 'Fill form',
    clientNameInfo: 'Client display name (used for logging and consent screen)',
    clientIdInfo: 'Unique ID of the client',
    clientUri: 'Client Uri',
    clientUriInfo: 'URI to further information about client (used on consent screen)',
    logoUri: 'Logo Uri',
    logoUriInfo: 'URI to client logo (used on consent screen)',
    allowedScopes: 'Allowed scopes',
    allowedScopesInfo:
      'By default a client has no access to any resources - specify the allowed resources by adding the corresponding scopes names',
    allowedGranttypes: 'Allowed granttypes',
    allowedGranttypesInfo:
      'Specifies the grant types the client is allowed to use. Use the GrantTypes class for common combinations.',
    protocolType: 'Protocol type',
    rowVersion: 'Row version',
    enableClient: 'Enable client',
    enableClientInfo: 'Specifies if client is enabled. Defaults to true.',
    allowOfflineAccessInfo:
      'Specifies whether this client can request refresh tokens (be requesting the offline_access scope)',
    allowOfflineAccess: 'Allow refreshtokens',
    requireClientSecret: 'Require client secret',
    requireClientSecretInfo:
      'Specifies whether this client needs a secret to request tokens from the token endpoint (defaults to true)',
    noAppSubscriptionRequired: 'No App Subscription required',
    allowAccessTokensViaBrowser: 'Allowe accesstokens via browser',
    allowAccessTokensViaBrowserInfo:
      'Specifies whether this client is allowed to receive access tokens via the browser. This is useful to harden flows that allow multiple response types (e.g. by disallowing a hybrid flow client that is supposed to use code id_token to add the token response type and thus leaking the token to the browser.',
    requirePkce: 'Require PKCE',
    requirePkceInfo:
      'Specifies whether clients using an authorization code based grant type must send a proof key (defaults to true).',
    allowPlainTextPkce: 'Allow plain text PKCE',
    allowPlainTextPkceInfo:
      'Specifies whether clients using PKCE can use a plain text code challenge (not recommended - and default to false)',
    redirectUrisInfo: 'Specifies the allowed URIs to return tokens or authorization codes to',
    redirectUris: 'Redirect uris',
    postLogoutRedirectUris: 'Post logout redirect uris',
    postLogoutRedirectUrisInfo:
      'Specifies allowed URIs to redirect to after logout. See the OIDC Connect Session Management spec for more details.',
    identityProviderRestrictions: 'Identity Provider Restrictions',
    identityProviderRestrictionsInfo:
      'Specifies which external IdPs can be used with this client (if list is empty all IdPs are allowed). Defaults to empty.',
    frontChannelLogoutSessionRequired: 'Frontchannel logoutsession is required',
    frontChannelLogoutSessionRequiredInfo:
      'Specifies if the user’s session id should be sent to the FrontChannelLogoutUri. Defaults to true.',
    frontChannelLogoutUri: 'Front channel logout uri',
    frontChannelLogoutUriInfo:
      'Specifies logout URI at client for HTTP based front-channel logout. See the OIDC Front-Channel spec for more details.',
    backChannelLogoutSessionRequired: 'Backchannel logoutsession is required',
    backChannelLogoutSessionRequiredInfo:
      'Specifies if the user’s session id should be sent in the request to the BackChannelLogoutUri. Defaults to true.',
    backChannelLogoutUri: 'Logout-uri:',
    backChannelLogoutUriInfo:
      'Specifies logout URI at client for HTTP based back-channel logout. See the OIDC Back-Channel spec for more details.',
    logoutSession: 'Logout session',
    enableLocalLogin: 'Enable local login',
    enableLocalLoginInfo:
      'Specifies if this client can use local accounts, or external IdPs only. Defaults to true.',
    accessTokenLifetime: 'Accesstoken lifetime',
    accessTokenLifetimeInfo:
      'Lifetime of access token in seconds (defaults to 3600 seconds / 1 hour)',
    absoluteRefreshTokenLifetime: 'Absolute refreshtoken lifetime',
    absoluteRefreshTokenLifetimeInfo:
      'Maximum lifetime of a refresh token in seconds. Defaults to 2592000 seconds / 30 days',
    identityTokenLifetime: 'Identitytoken lifetime',
    identityTokenLifetimeInfo:
      'Lifetime to identity token in seconds (defaults to 300 seconds / 5 minutes)',
    authorizationCodeLifetime: 'Authorization code lifetime',
    authorizationCodeLifetimeInfo:
      'Lifetime of authorization code in seconds (defaults to 300 seconds / 5 minutes)',
    slidingRefreshTokenLifetime: 'Sliding refreshtoken lifetime',
    slidingRefreshTokenLifetimeInfo:
      'Sliding lifetime of a refresh token in seconds. Defaults to 1296000 seconds / 15 days',
    clientClaimsPrefix: 'Client claims prefix',
    clientClaimsPrefixInfo:
      'If set, the prefix client claim types will be prefixed with. Defaults to client_. The intent is to make sure they don’t accidentally collide with user claims.',
    pairWiseSubjectSalt: 'Paire wise subject salt',
    pairWiseSubjectSaltInfo:
      'Salt value used in pair-wise subjectId generation for users of this client.',
    updateAccessTokenClaimsOnRefresh: 'Update accesstoken claims on refresh',
    updateAccessTokenClaimsOnRefreshInfo:
      'Gets or sets a value indicating whether the access token (and its claims) should be updated on a refresh token request.',
    accessTokenType: 'Reference accesstoken',
    accessTokenTypeInfo:
      'Specifies whether the access token is a reference token or a self contained JWT token (defaults to Jwt).',
    includeJwtId: 'Include JWT ID',
    includeJwtIdInfo:
      'Specifies whether JWT access tokens should have an embedded unique ID (via the jti claim). Defaults to true.',
    alwaysSendClientClaims: 'Always send client claims',
    alwaysSendClientClaimsInfo:
      'If set, the client claims will be sent for every flow. If not, only for client credentials flow (default is false)',
    alwaysIncludeUserClaimsInIdToken: 'Always include user claims in identity token',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'When requesting both an id token and access token, should the user claims always be added to the id token instead of requiring the client to use the userinfo endpoint. Default is false.',
    allowedCorsOriginsInfo:
      'If specified, will be used by the default CORS policy service implementations (In-Memory and EF) to build a CORS policy for JavaScript clients.',
    allowedCorsOrigins: 'Allowed CORS origins',
    consentLifetimeInfo: 'Lifetime of a user consent in seconds. Defaults to null (no expiration).',
    consentLifetime: 'Consent lifetime',
    requireConsent: 'Require consent',
    requireConsentInfo: 'Specifies whether a consent screen is required. Defaults to false.',
    allowRememberConsent: 'Allow remember consent',
    allowRememberConsentInfo:
      'Specifies whether user can choose to store consent decisions. Defaults to true.',
    refreshTokenUsage: 'Refresh token usage',
    refreshTokenUsageInfo:
      "'ReUse' the refresh token handle will stay the same when refreshing tokens. 'OneTime' the refresh token handle will be updated when refreshing tokens. This is the default.",
    refreshTokenExpiration: 'Refreshtoken expiration',
    refreshTokenExpirationInfo:
      "'Absolute' the refresh token will expire on a fixed point in time (specified by the AbsoluteRefreshTokenLifetime). This is the default. 'Sliding' when refreshing the token, the lifetime of the refresh token will be renewed (by the amount specified in SlidingRefreshTokenLifetime). The lifetime will not exceed AbsoluteRefreshTokenLifetime.",
    reUse: 'Reuse',
    oneTimeOnly: 'One time only',
    sliding: 'Sliding',
    absolute: 'Absolute',
    updateUserFailed: 'Update user failed',
    getUserFailed: 'Get user failed',
    isHidden: 'Hidden',
    isOwner: 'Owner',
    updateSuiteFailed: 'Update suite failed',
    updateSuiteSuccess: 'Update suite success',
    suites_plural: 'Suites',
    suites: 'Suite',
    tiers: 'Tiers',
    apps: 'App',
    addAppFeature: 'Add app feature',
    tierApps: 'Tier apps',
    suite: 'Suite',
    tier: 'Tier',
    suiteTier: 'Tier',
    suiteIdEmptyErr: 'Please select a suite',
    suiteTierIdEmptyErr: 'Please select a tier',
    timezone: 'Time zone',
    communityMembers: 'community member',
    communityMembers_plural: 'Community members',
    getCommunityRolesFailed: 'Get community roles failed',
    myApps: 'My apps',
    principalJoinRequests: 'Join requests',
    selectExistingUser:
      "Search for an existing user (this will override the existing user's profile with the information below)",
    acceptJoinRequestFor: 'Accept join request of {{user}}',
    preApproveForLinking: 'Pre-approve for linking',
    areYouSureYouWantToUnlinkIdentity: 'Are you sure you want to unlink the account from the user?',
    preApproveForLinkingInfo:
      'Automatically approve the join request if someone wants to link his account to this user',
    acceptJoinRequestFailed: 'Accept join request failed',
    acceptJoinRequestSuccess: 'Accept join request success',
    viewOrganisation: 'View organisation',
    myIdentity: 'My account',
    active: 'Active',
    activeState: 'Active state',
    activeStatus: 'Active status',
    addApplication: 'Add app',
    addAppSubscription: 'Add app subscription',
    addCommunityRoleFailed: "Couldn't add the community role",
    addCommunityRoleSuccess: 'The community role has been added',
    addFeature: 'Add feature',
    addOwner: 'Add owner',
    addRole: 'Add role',
    addSubscription: 'Add subscription',
    addSuite: 'Add suite',
    addTier: 'Add tier',
    addUser: 'Add user',
    alias: 'Alias',
    aliasEmptyErr: 'Please enter an alias',
    appDetailsAliasEmptyErr: 'Please enter an alias',
    appDetailsTagEmptyErr: 'Please select an app',
    appDetailsUrlEmptyErr: 'Please enter an url',
    appFeatures: 'App features',
    appInstallationFeatureTagEmptyErr: 'Please select a feature',
    appInstallationIdEmptyErr: 'Please select an app',
    appInstallations: 'App installations',
    application: 'App',
    apps_plural: 'Apps',
    appSubscription: 'App subscription',
    appTypeIdEmptyErr: 'Please select an app type',
    areYouSureRemoveIdentificationCodeType:
      'Are you sure you want to remove this identificationcode type?',
    areYouSureRemoveOnboardingTemplate: 'Are you sure you want to remove this onboarding template?',
    areYouSureRemovePrincipal: 'Are you sure you want to remove this user?',
    areYouSureRemoveRelation: 'Are you sure you want to remove this relation?',
    areYouSureYouWantToDenyJoinRequest: 'Are you sure you want to deny this join request?',
    cityEmptyErr: 'Please fill in a city',
    close: 'Close',
    community: 'Community',
    communityApps: 'Community app',
    communityApps_plural: 'Community apps',
    communityMemberCreatedAndInvited:
      'The community member has been created and user has been invited',
    communityMemberCreatedAndInvitedError:
      "Couldn't create the community member and invite the user",
    communityRoles: 'Community role',
    communityRoles_plural: 'Community roles',
    communitySuites: 'Community suite',
    communitySuites_plural: 'Community suites',
    confirmInvitationInfo:
      'Please confirm the details below are correct. In the next steps you can complete your account information and finish the registration process.',
    couldNotCompleteInvitation:
      'Unfortunately we could not complete your invitation.<0></0>Try again or contact our support desk <1>{{text}}</1>.',
    countryEmptyErr: 'Please select a country',
    createAppFailed: "Couldn't create the app",
    createAppSubscriptionFailed: "Couldn't create the app subscription",
    createAppSubscriptionSuccess: 'The app subscription has been created',
    createAppSuccess: 'The app has been created',
    createCommunityAppFailed: "Couldn't create the community app",
    createCommunityAppSuccess: 'The community app has been created',
    createCommunityMemberFailed: "Couldn't create the community member",
    createCommunityMemberSuccess: 'The community member has been created',
    createCommunitySuiteFailed: "Couldn't create the community suite",
    createCommunitySuiteSuccess: 'The community suite has been created',
    createIdentificationCodeTypeFailed: "Couldn't create the identificationcode type",
    createIdentificationCodeTypeSuccess: 'The identificationcode type has been created',
    createNewMember: 'Create new member',
    createNewOrganisation: 'Create new organisation',
    createOnboardingTemplateFailed: "Couldn't create the onboarding template",
    createOnboardingTemplateSuccess: 'The onboarding template has been created',
    createOrganisationRoleFailed: "Couldn't create the organisation role",
    createOrganisationRoleSuccess: 'The organisation role has been created',
    createPrincipalFailed: "Couldn't create the user",
    createPrincipalSuccess: 'The user has been created',
    createRelationFailed: "Couldn't create the relation",
    createRelationSuccess: 'The relation has been created',
    createRelationTypeFailed: "Couldn't create the relation type",
    createRelationTypeSuccess: 'The relation type has been created',
    createSuiteFailed: "Couldn't create the suite",
    createSuiteSuccess: 'The suite has been created',
    createUserFailed: "Couldn't create the user",
    createUserSuccess: 'The user has been created',
    defaultCommunity: 'Default community',
    deleted: 'Deleted',
    denyJoinRequestFailed: "Couldn't deny the join request",
    denyJoinRequestSuccess: 'The join request has been denied',
    descriptionEmptyErr: 'Please fill in a description',
    details: 'Details',
    displayName: 'Display name',
    editApp: 'Edit app',
    editCommunityApp: 'Edit community app',
    editCommunityMember: 'Edit community member',
    editCommunityRole: 'Edit community role',
    editFeature: 'Edit feature',
    editOrganisationRole: 'Edit organisation role',
    editSubscription: 'Edit subscription',
    email: 'Email address',
    emailAddress: 'Email address',
    emailAddressEmptyErr: 'Please fill in an e-mail address',
    emailOrPhoneNumberRequiredError: 'A valid email address or phone number is required',
    externalIdentifier: 'External identifier',
    feature: 'Feature',
    features: 'Features',
    featureSubscriptions: 'Subscriptions',
    firstSelectAFeature: 'First select a feature',
    firstSelectAnApp: 'First select an app',
    fullNameEmptyErr: 'Please enter a full name',
    general: 'General',
    getAppFailed: "Couldn't get the app",
    getAppInstallationFailed: "Couldn't get the app installation",
    getAppInstallationsFailed: "Couldn't get the app installations",
    getAppsFailed: "Couldn't get the apps",
    getAppSubscriptionsFailed: "Couldn't get the app subscriptions",
    getAvailableRolesFailed: "Couldn't get the available roles",
    getCommunityAppsFailed: "Couldn't get the community apps",
    getCommunityMemberRolesFailed: "Couldn't get the roles for this organisation",
    getIdentificationCodeTypeFailed: "Couldn't get the identification type",
    getJoinRequestFailed: "Couldn't get the join request",
    getOnboardingTemplateFailed: "Couldn't get the onboarding template",
    getOrganisationRolesFailed: "Couldn't get the roles",
    getPrincipalFailed: "Couldn't get the user",
    getRelationFailed: "Couldn't get the relation",
    getRelationsFailed: "Couldn't get the relations",
    getRelationTypeFailed: "Couldn't get the relation type",
    getRelationTypesFailed: "Couldn't get the relation types",
    getSuiteFailed: "Couldn't get the suite",
    getSuitesFailed: "Couldn't get the suites",
    global: 'Global',
    here: 'here',
    hostedAt: 'Hosted at',
    identificationcodetypes: 'Identificationcode type',
    identificationcodetypes_plural: 'Identificationcode types',
    identities: 'Accounts',
    identity: 'Account',
    inactive: 'Inactive',
    installationIndex: 'Installation index',
    introducedInVersion: 'Introduced in version',
    introducedInVersionEmptyErr: 'Please enter in which version this feature was introduced',
    invalidInvitation1: 'Something went wrong while getting your invitation.',
    invalidInvitation2: 'It may be expired or it does not exist.',
    invitationExpiresOn: 'Invitation expires on',
    invitationInfo:
      '<bold>{{username}}</bold> from organisation <bold>{{organisation}}</bold> has invited you to join the <bold>{{community}}</bold> community.',
    invitationSentOn: 'Invitation sent on',
    invitationState: 'Invitation state',
    invitationType: 'Invitation type',
    invited: 'Invited',
    inviteFreeText: 'Add a message that will be included in the invitation e-mail',
    isCustomer: 'Is customer',
    isGloballyManaged: 'Available for community admins',
    isOptional: 'Is optional',
    isSystem: 'Is system',
    isVisible: 'Is visible',
    joinMessage: 'Your message for the community admin',
    joinRequestAcceptedInfo: 'Dear {{fullName}}, your join request has been approved.',
    joinRequestError: 'Join request could not be sent',
    joinRequestErrorMessage:
      'Something went wrong while sending your join request to the community admin. Please try again later.',
    joinRequests: 'Join requests',
    joinRequestSentToCommunityAdmin: 'Join request sent to community admins',
    joinRequestSentToCommunityAdminDescription:
      'Your join request has been sent to the community admins to grant you access to community apps.',
    languageEmptyErr: 'Please select a language',
    languageIdEmptyErr: 'Please select a language',
    linkExistingOrganisation: 'Link existing organisation',
    linkIdentityFailed: 'Could not link account to user',
    linkIdentitySuccess: 'Account linked to user',
    linkMyIdentityToPrincipal: 'Link my account to user',
    location: 'Location',
    lockedOut: 'Locked out',
    management: 'Management',
    mine: '(my account)',
    newApp: 'New app',
    newAppSubscription: 'New app subscription',
    newCommunityApp: 'New community app',
    newCommunityMember: 'New community member',
    newCommunityRole: 'New community role',
    newCommunitySuite: 'New community suite',
    newFeature: 'New feature',
    newIdentificationCodeType: 'Add type',
    newOnboardingTemplate: 'New onboarding template',
    newOrganisationRole: 'New organisation role',
    newRelation: 'New relation',
    newRelationType: 'New relation type',
    newSuite: 'New suite',
    newUser: 'New user',
    noAppsConfiguredForOnboardingTemplate: 'No apps configured for template.',
    noFeaturesDefined: 'No features defined',
    noFeaturesDefinedYet: 'No features configured yet',
    noFeaturesFound: 'No features found',
    noLinkedAccountsYet: 'No linked accounts yet.',
    noPendingInvitationsFound: 'No pending invitations found',
    noRolesDefined: 'No roles defined',
    noSuitesFound: 'No suites found',
    noTiersFound: 'No tiers found',
    noUsersFound: 'No users found',
    noValidPeriod: 'Automatically subscribed',
    organisationCityEmptyErr: 'Please enter a city',
    organisationCountryEmptyErr: 'Please enter a country',
    organisationDetailsDescription: 'Fill in the details of the organisation',
    organisationNameEmptyErr: 'Please enter an organisation name',
    organisationRole: 'Organisation role',
    organisationRoles: 'Organisation role',
    organisationRoles_plural: 'Organisation roles',
    organisations: 'Organisations',
    organisationsOverview: 'Organisations overview',
    owners: 'Owners',
    parentOrganisation: 'Parent organisation',
    passwordToDelete: 'Password to delete',
    pending: 'Pending',
    pendingInvitations: 'Pending invitation',
    pendingInvitations_plural: 'Pending invitations',
    phoneNumber: 'Phone number',
    pleaseAcceptOurTermsAndConditions: 'Please accept our terms and conditions',
    pleaseCompleteOrganisationDetails: 'Please complete the details of your organisation below.',
    postalCodeEmptyErr: 'Please fill in a postal code',
    primaryEmailAddressEmptyErr: 'Please enter a valid email address',
    primaryPhoneNumberEmptyErr: 'Please enter a valid phone number',
    principalFullNameEmptyErr: 'Please enter a full name',
    principalLanguageIdEmptyErr: 'Please select a language',
    principals: 'user',
    principalTimeZoneEmptyErr: 'Please select a time zone',
    reInvite: 'Re-invite',
    relationType: 'Relation',
    relationTypeIdEmptyErr: 'Please select a relation type',
    relationTypes: 'Relation type',
    relationTypes_plural: 'Relation types',
    removeApp: 'Remove app',
    removeAppAndRoles: 'Remove app, features & roles',
    removeAppSubscriptionFailed: 'Remove subscription failed',
    removeAppSubscriptionSuccess: 'Remove subscription success',
    removeFeature: 'Remove feature',
    removeThisFeature: 'Remove this feature',
    removeThisRole: 'Remove role',
    removeThisSuite: 'Remove this suite',
    removeThisTier: 'Remove this tier',
    requestToJoin: 'Request to join',
    requestToJoinInfo:
      'If your organisation would like to join this community, please fill in the form.<br/>The community admin will review your application and contact you shortly.',
    requiresSubscription: 'Require subscription',
    resendInvitationFailed: "Couldn't resend the invitation",
    resendInvitationSuccess: 'The invitation has been resent',
    resetPassword: 'Reset password',
    reviewJoinRequest: 'Review join request',
    selectAnApp: 'Select an app',
    selectAnApplication: 'Select an app',
    sendInvitation: 'Send invitation',
    sometingWentWrong: 'Something went wrong',
    source: 'Source',
    sourceIdEmptyErr: 'Please select a source',
    sourceOrganisationRoles: 'Source organisation roles',
    stateName: 'State',
    status: 'Status',
    streetAndNumberEmptyErr: 'Please fill in a street & number',
    tag: 'Tag',
    tagEmptyErr: 'Please fill in a tag',
    tagExplainer: 'Starts with alphabetic character, max length of 20',
    target: 'Target',
    targetIdEmptyErr: 'Please select a target',
    targetOrganisationRoles: 'Target organisation roles',
    template: 'Template',
    templateHasNoConfiguration: 'Template has no configuration',
    templateInfo1:
      'A template will give the administrator access to a set of apps and give him a list of organisation roles.',
    templateInfo2: 'Select a template to view its configuration',
    textMessage: 'Text message',
    noUserGroupsFound: 'No user groups found',
    areYouSureRemoveUserGroup: 'Are you sure you want to remove this user group?',
    createUserGroupFailed: "Couldn't create user group",
    createUserGroupSuccess: 'User group created',
    updateUserGroupFailed: "Couldn't update user group",
    updateUserGroupSuccess: 'User group updated',
    getUserGroupFailed: "Couldn't get user group",
    addUserGroup: 'Add user group',
    newUserGroup: 'New user group',
    noAppsFeaturesRolesDefined: 'No apps, features, roles defined',
    createUserGroupMemberFailed: "Couldn't create user group member",
    createUserGroupMemberSuccess: 'User group member created',
    removeUserGroupMemberFailed: "Couldn't remove user group member",
    removeUserGroupMemberSuccess: 'User group member remove',
    getUserGroupMembersFailed: "Couldn't get user group members",
    membersOfUserGroup: 'Members of user group',
    timezoneEmptyErr: 'Please select a time zone',
    timeZoneEmptyErr: 'Please select a time zone',
    timeZoneIdEmptyErr: 'Please select a timezone',
    unauthorized: 'You are not authorized to perform this action.',
    unlink: 'Unlink',
    unlinkIdentityFailed: "Couldn't unlink the account",
    unlinkIdentitySuccess: 'The account has been unlinked',
    unlisted: 'Unlisted',
    updateAppFailed: "Couldn't update the app",
    updateAppSubscriptionFailed: "Couldn't update the app subscription",
    updateAppSubscriptionSuccess: 'The app subscription has been updated',
    updateAppSuccess: 'The app has been updated',
    updateCommunityAppFailed: "Couldn't update the community app",
    updateCommunityAppSuccess: 'The community app has been updated',
    updateCommunityMemberFailed: "Couldn't update the community member",
    updateCommunityMemberRolesFailed: "Couldn't update the community member roles",
    updateCommunityMemberRolesSuccess: 'The community member roles have been updated',
    updateCommunityMemberSuccess: 'The community member has been updated',
    updateCommunityRoleFailed: "Couldn't update the community role",
    updateCommunityRoleSuccess: 'The community role has been updated',
    updateCommunitySuiteFailed: "Couldn't update the community suite",
    updateCommunitySuiteSuccess: 'The community suite has been updated',
    updateIdentificationCodeTypeFailed: "Couldn't update the identificationcode type",
    updateIdentificationCodeTypeSuccess: 'The identificationcode type has been updated',
    updateOnboardingTemplateFailed: "Couldn't update the onboarding template",
    updateOnboardingTemplateSuccess: 'The onboarding template has been updated',
    updateOrganisationRoleFailed: "Couldn't update the organisation role",
    updateOrganisationRoleSuccess: 'The organisation role has been updated',
    updatePrincipalFailed: "Couldn't update the user",
    updatePrincipalSuccess: 'The user has been updated',
    updateRelationFailed: "Couldn't update the relation",
    updateRelationSuccess: 'The relation has been updated',
    updateRelationTypeFailed: "Couldn't update the relation type",
    updateRelationTypeSuccess: 'The relation type has been updated',
    updateUserSuccess: 'The user has been updated',
    url: 'Url',
    urlEmptyErr: 'Please enter an url',
    useATemplate: 'Use a template',
    user: 'User',
    userDetailsDescription: 'Fill in the user details',
    validationPattern: 'Validation pattern',
    validFrom: 'Valid from',
    validPeriod: 'Valid period',
    validUntil: 'Valid until',
    verifiedStatus: 'Verified status',
    view: 'View',
    viewSubscribedOrganisations: 'View subscribed organisations',
    viewTemplate: 'View template',
    welcomeToThePlatform: 'Welcome to the platform!',
    welcomeToThePlatformInfo:
      'Your user account has been successfully registered on the Nallian platform. To continue and start using the applications, please click "Proceed" to login to the Nallian Portal.',
    searchAndAddMember: 'Search and add a member',
    searchForNameOrEmailOfUser: 'Search for a name or email of a user',
    editUserGroup: 'Edit user group',
    manageMembers: 'View/manage members',
    userGroupHasNoMembers: 'This user group has no members',
    organisationsForRole: 'Organisations for community role',
    noOrganisationsFound: 'No organisations found',
    viewOrganisations: 'View organisations',
    appSubscriptions: 'App Subscriptions',
    createdByOrganisation: 'Created by organisation',
    metaData: 'Meta data',
    lastModifiedOn: 'Last modified on',
    linkedAccounts: 'Linked accounts',
    relations: 'Relations',
    youHaveBeenInvited: 'You have been invited',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Are you sure want to remove the subscription for this feature? Access to this feature will be revoked for all the users of this organisation.',
    applyOnboardingTemplate: 'Apply onboarding template',
    getOnboardingTemplatesFailed: 'Could not get onboarding templates',
    selectAnOnboardingTemplate: 'Select an onboarding template',
    onboardingTemplateIdEmptyErr: 'Please select an onboarding template',
    applyOnboardingTemplateFailed: 'Could not apply onboarding template',
    applyOnboardingTemplateSuccess: 'Onboarding template applied',
    addTemplateInfo:
      'The template will add the following apps & community roles to the organisation',
    filters: 'Filters',
    filterOnUserRole: 'Filter on user role',
    identityOrClient: 'Account or client',
    searchForAnIdentityOrAddClientId: 'Search for an account or add a client ID',
    filterOnIdentificationCode: 'Filter on identification code',
    useNoTemplate: 'Use no template',
    templateInfo: 'Select a template',
    userInfo: 'User info',
    invalidUrlCommuntiyAppFeature: 'Must be a valid URL or must contain [EnvironmentUrl]',
    communitiesOverview: 'Communities overview',
    createCommunityFailed: "Couldn't create community",
    createCommunitySuccess: 'Community created',
    newCommunity: 'New community',
    themeName: 'Theme name',
    defaultLanguage: 'Default language',
    mustBeValidUrl: 'Must be a valid URL',
    updateCommunityFailed: "Couldn't update community",
    updateCommunitySuccess: 'Community updated',
    fixedCommunityId:
      'ID (not mandatory, only if you want the same community ID on all environments)',
    updateNotificationSettingsFailed: "Couldn't update notification settings",
    updateNotificationSettingsSuccess: 'Notification settings updated',
    notificationSettings: 'Notification settings',
    fromName: 'From name',
    fromEmail: 'From email',
    replyToEmail: 'Reply to email',
    replyToName: 'Reply to name',
    emailSubjectPrefix: 'Email subject prefix',
    contactEmail: 'Contact email',
    updateHostsFailed: "Couldn't update hosts",
    updateHostsSuccess: 'Hosts updated',
    noHostsYet: 'No hosts yet',
    addHost: 'Add host',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Is primary',
    onlyOnePrimaryHost: 'Only one host can be primary',
    minOnePrimaryHost: 'Minium one host must be primary',
    pleaseEnterAHost: 'Please enter a (valid) host',
    tenantId: 'Tenant ID',
    tenantHostUrl: 'Tenant host url',
    tenantInformation: 'Tenant information',

    communityWelcomeText: 'Community welcome text',
    legalDocuments: 'Legal documents',
    uploadNewGeneralTermsAndConditions: 'Upload new General Terms & Conditions',
    documents: 'Documents',
    title: 'Title',
    revision: 'Revision',
    download: 'Download',
    // theme lookups (internal)
    themeLookups_plural: 'Theme lookups',
    newThemeLookup: 'New theme lookup',
    createThemeLookupFailed: "Couldn't create theme lookup",
    createThemeLookupSuccess: 'Theme lookup created',
    updateThemeLookupFailed: "Couldn't update theme lookup",
    updateThemeLookupSuccess: 'Theme lookup updated',
    editThemeLookup: 'Edit theme lookup',
    themeLookups: 'Theme lookup',
    titleEmptyErr: 'Please enter a title',
    hostEmptyErr: 'Please enter a host',
    themeNameEmptyErr: 'Please enter a theme name',
    editCommunityTextFailed: "Couldn't update community text",
    editCommunityTextSuccess: 'Community text updated',
    documentUploaded: 'Document uploaded',
    documentUploadFailed: 'Document upload failed',
    noCommunityTextYet: 'No community welcome text yet',
    noDocumentsYet: 'No documents yet',
    addLanguage: 'Add language',
    enterLanguageKey: 'Enter your language key',
    emailNotificationFooter: 'Email notification footer',
    emailNotificationHeader: 'Email notification header',
    blobsUpdated: 'Blobs updated',
    blobsNotUpdated: 'Failed to update blobs',
    removeCommunityAppClientFailed: "Couldn't remove client",
    removeCommunityAppClientSuccess: 'Client removed',
    createCommunityAppClientFailed: "Couldn't create client",
    createCommunityAppClientSuccess: 'Client created',
    getCommunityAppClientsFailed: "Couldn't get clients",
    manageClientsForCommunityApp: 'Manage clients',
    addClient: 'Add client',
    manageAppClients: 'Manage app clients',
    noClientsYet: 'No clients yet',
    unknownIdentityProvider: 'Unknown identity provider',
    areYouSureRemoveOrganisation:
      'Are you sure you want to remove the organisation "{{item.name}}"?',
    timeSettings: 'Time settings',
    userDetails: 'User details',
    appsAndRoles: 'Apps & roles',
    accountsIdentities: 'Linked accounts',
    accounts: 'Accounts',
    areYouSureContinueWithoutUserHasRoles:
      'Are you sure you do not want to give access to any application for this user?',
    principalRemoved: 'User removed',
    userGroups: 'User groups',
    selectUserGroups: 'Select user groups',
    data: 'Data',
    id: 'ID',
    shortName: 'Short name',
    installations: 'Installations',
    isGlobal: 'Is global',
    isCrossCommunity: 'Is cross community',
    isObsolete: 'Is obsolete',
    copyToClipboard: 'Copy to clipboard',
    administrators: 'Administrators',
    welcomeText: 'Community welcome text',
    overviewText: 'Home page overview text',
    pleaseTypeToEnableConfirmButton: "Please type '{{message}}' to enable the confirm button.",
    pleaseTypeHere: 'Please type here',
    removeOrganisation: 'Remove organisation',
    removeOrganisationFailed: 'Could not remove organisation',
    removeOrganisationSuccess: 'Organisation removed',
    removeAppInstallation: 'Remove app installation',
    areYouSureRemoveAppInstallation:
      'Are you sure you want to remove the app installation "{{item.name}}"?',
    removeAppInstallationFailed: 'Could not remove app installation',
    removeAppInstallationSuccess: 'App installation removed',
    identificationCodesCount: '{{count}} identification code(s)',
    noIdentificationCodes: 'No identification codes',
    noRoles: 'No roles',
    rolesCount: '{{count}} role(s)',
    noIdentificationCodeTypesFound: 'No identification code types found',
    isRequired: 'Is required',
    identificationCodeTypeTagEmptyErr: 'Please select an identification code type',
    editType: 'Edit type',
    theFollowingIdentificationCodeTypesAreRequired:
      'The following identification codes are missing: {{missingTypes}}',
    updateContactFailed: 'Could not update contact',
    updateContactSuccess: 'Contact updated',
    createContactFailed: 'Could not create contact',
    createContactSuccess: 'Contact created',
    removeContactFailed: 'Could not remove contact',
    removeContactSuccess: 'Contact removed',
    contacts: 'Contacts',
    noContactsYet: 'No contacts yet.',
    newContact: 'New contact',
    editContact: 'Edit contact',
    areYouSureYouWantToRemoveContact: 'Are you sure you want to remove this contact?',
    logo: 'Logo',
    uploadANewLogo: 'Upload a new logo',
    noLogoAvailable: 'No logo yet.',
    viewLogo: 'View logo',
    uploadLogo: 'Upload logo',
    removeOrganisationLogoFailed: 'Could not remove logo',
    removeOrganisationLogoSuccess: 'Logo removed',
    uploadLogoSuccess: 'Logo uploaded',
    uploadLogoError: 'Could not upload logo',
    removeLogo: 'Remove logo',
    areYouSureYouWantToRemoveLogo: 'Are you sure you want to remove the logo?',
    fileEmptyErr: 'Please upload a valid file',
    noFeatureDetails: 'No feature details',
    pleaseSelectRoles: 'Please select one or more roles',
  },
  de: {
    noCommunityData: 'Keine Community-Daten verfügbar',
    password: 'Passwort',
    verifyPassword: 'Passwort bestätigen',
    passwordsDontMatch: 'Die Passwörter stimmen nicht überein',
    userName: 'Benutzername (E-Mail)',
    language: 'Sprache',
    timezone: 'Zeitzone',
    fullName: 'Vollständiger Name',
    next: 'Weiter',
    continue: 'Weiter',
    nameRequired: 'Bitte geben Sie einen Namen an',
    cityRequired: 'Bitte geben Sie eine Stadt an',
    descriptionRequired: 'Bitte geben Sie eine Beschreibung an',
    selectCountry: 'Bitte wählen Sie ein Land',
    name: 'Name',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    streetAndNumber: 'Straße und Nummer',
    country: 'Land',
    suggestionsRequired: 'Bitte wählen Sie eine Organisation',
    streetAndNumberRequired: 'Straße und Hausnummer sind erforderlich',
    postalCodeRequired: 'Postleitzahl ist erforderlich',
    suggestions: 'Vorschläge',
    selectPlaceholder: 'Wählen...',
    createAnAccount: 'Bitte erstellen Sie ein Benutzerkonto',
    loginToYourAccount: 'Bitte melden Sie sich mit Ihrem Benutzerkonto an',
    join: 'Beitreten',
    joinOrganisationOnPlatform:
      'Bitte treten Sie einer Organisation bei, die bereits auf der Plattform vorhanden ist',
    register: 'Registrieren',
    registerOrganisationOnPlatform:
      'Bitte registrieren Sie eine neue Organisation auf der Plattform',
    confirmationEmailSent: 'Eine Bestätigungsmail wurde gesendet',
    resendEmail: 'E-Mail erneut senden',
    confirmationEmailContent:
      'Eine E-Mail wurde an {{email}} gesendet.\n\nBitte öffnen Sie Ihre E-Mail und klicken Sie auf den Bestätigungslink, um mit Ihrer Registrierung fortzufahren. Wenn Sie eine E-Mail nicht finden können, überprüfen Sie Ihren SPAM oder senden Sie die E-Mail mit der Schaltfläche unten erneut.\n\nDieses Fenster kann geschlossen werden',
    passwordRequired: 'Bitte geben Sie ein Passwort ein',
    reEnterPassword: 'Bitte geben Sie Ihr Passwort erneut ein',
    joinRequestSent: 'Beitrittsanfrage abgeschickt',
    joinRequestContent:
      'Bitte warten Sie auf die Bestätigung Ihrer Beitrittsanfrage durch den Administrator',
    readAllLegalDocuments:
      'Ich habe die oben genannten Dokumenten gelesen und bin damit einverstanden',
    sign: 'Akzeptieren',
    welcome: 'Herzlich willkommen',
    chooseRoles: 'Bitte wählen Sie Benutzerrollen',
    login: 'Bitte einloggen',
    communityMembershipTemplateGetFailed:
      'Es ist ein Fehler aufgetreten. Das System konnte keine Community-Vorlagen abrufen',
    membershipAlreadyRequested: 'Die Mitgliedschaft ist bereits angefordert',
    noLegalDocumentsToSign: 'Es sind keine Dokumente zum Unterschreiben vorhanden',
    welcomeToTheCommunity: 'Willkommen in der Community',
    viewApps: 'Schauen Sie sich die Apps an',
    membershipRequestFailed: 'Die Anfrage zur Teilnahme an der Community ist fehlgeschlagen',
    error: 'Fehler',
    chooseSuggestedOrganisationToJoin:
      'Anhand Ihrer E-Mail-Adresse möchten Sie möglicherweise einer der folgenden bestehenden Organisationen beitreten.',
    joinSuggestedOrganisation:
      'Anhand Ihrer E-Mail-Adresse möchten Sie möglicherweise dieser bestehenden Organisation beitreten.',
    selectAnOrganisation: 'Bitte wählen Sie eine Organisation',
    organisationName: 'Name der Organisation',
    back: 'Zurück',
    addIdentificationCode: 'Bitte fügen Sie einen Identifikationscode hinzu',
    identificationCode: 'Identifikationscode',
    welcomeMessageTitle: 'Willkommen auf der Plattform!',
    selectLanguage: 'Bitte wählen Sie eine Sprache',
    selectTimezone: 'Bitte wählen Sie eine Zeitzone',
    type: 'Art',
    organisationNameAlreadyExists: 'Name der Organisation ist bereits vorhanden',
    errorWhileValidatingOrganisationName:
      'Beim Überprüfen des Organisationsnamens ist ein Fehler aufgetreten',
    thisIdentificationCodeIsAlreadyInUse: 'Der Identifikationscode ist bereits vorhanden',
    errorWhileIdentificationCodeName:
      'Beim Überprüfen des Identifikationscodes ist ein Fehler aufgetreten',
    passwordMinimum12charactersErr: 'Ein Passwort muss aus mindestens 12 Zeichen bestehen',
    passwordMaximum80charactersErr: 'Ein Passwort kann maximal 80 Zeichen enthalten',
    createUser: 'Benutzer erstellen',
    signLegalDocuments: 'Nutzungsbedingungen',
    invalidEmailErr: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    successfullyReceivedRegistration:
      'Wir haben Ihre Registrierung erfolgreich erhalten. Sie erhalten innerhalb eines Arbeitstages eine E-Mail mit einem Link, über den Sie auf die Anwendung (en) zugreifen können, für die Sie sich registriert haben.',
    furtherQuestions:
      'Wenn Sie weitere Fragen haben, wenden Sie sich bitte an Ihren Community-Administrator.',
    dear: 'Sehr geehrter {{user}},',
    'sorry!': 'Entschuldigung!',
    pageRequestedNotFound: 'Die von Ihnen angeforderte Seite wurde nicht gefunden.',
    toTheCommunityPortal: 'Zum Community-Portal.',
    addApp: 'App hinzufügen',
    app: 'App',
    role: 'Rolle',
    registerError: 'Bei der Registrierung ist ein Fehler aufgetreten.',
    contactAdministrator:
      'Weitere Informationen zur Verwendung dieses Community-Portals erhalten Sie von Ihrem Community-Administrator.',
    registerEmailDomainAsTrustedRequired: 'Sie müssen dieses Feld aktivieren oder deaktivieren.',
    proceed: 'Vorgehen',
    privateCommunityTitle: 'Private Gemeinschaft',
    privateCommunityDescription:
      'Dies ist eine private Gemeinschaft, der man nicht beitreten kann.',

    pleaseSelectOrganisation: 'Bitte wählen Sie eine Organisation aus',
    pleaseSelectMinimumOneRole: 'Bitte wählen Sie mindestens eine Rolle aus',
    organisation: 'Organisation',
    roles: 'Rollen',
    communityMembers: 'Community-Mitglied',
    communityMembers_plural: 'Community-Mitglieder',
    edit: 'Bearbeiten',
    editMembership: 'Mitgliedschaft bearbeiten',
    noMembersPresent: 'Keine Mitglieder anwesend.',
    state: 'Zustand',
    updateMembershipOf: 'Mitgliedschaft aktualisieren {{organisationName}}',
    addACommunityMember: 'ein Community-Mitglied hinzufügen',
    communityMembershipEnded: 'Community-Mitgliedschaft beendet',
    endCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Mitgliedschaft konnte nicht beendet werden.',
    communityMembershipUpdate: 'Community-Mitgliedschaft wurde aktualisiert.',
    updateCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Community-Mitgliedschaft konnte nicht aktualisiert werden.',
    getCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Community-Mitgliedschaft konnte nicht abgerufen werden.',
    communityMembershipCreated: 'Community-Mitglied erstellt',
    createCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Es konnte kein Community-Mitglied erstellt werden.',
    none: 'Keiner',
    requestOfOrganisation: 'Anfrage von {{organisation}}',
    applications: 'Anwendungen',
    signedLegalDocuments: 'Vereinbarte rechtliche Dokumente',
    areYouSureYouWantToDenyOrganisation:
      'Möchten Sie den Zugriff auf diese Organisation wirklich verweigern?',
    cancel: 'Abbrechen',
    deny: 'Verweigern',
    accept: 'Akzeptieren',
    createdOn: 'Erstellt am',
    actions: 'Aktionen',
    noMembershipRequests: 'Keine Mitgliedschaftsanfragen vorhanden',
    membershipRequests: 'Mitgliedschaftsanträge',
    membershipRequestGetFailed:
      'Es ist ein Fehler aufgetreten: Es konnten keine Mitgliedschaftsanfragen abgerufen werden.',
    membershipRequestUpdateFailed: 'Die Mitgliedschaftsanfrage konnte nicht aktualisiert werden',
    membershipRequestUpdateSuccess: 'Mitgliedschaftsanfrage aktualisiert',
    getCommunityRolesFailed:
      'Es ist ein Fehler aufgetreten: Es konnten keine Community-Rollen abgerufen werden.',
    members: 'Mitglieder',
    getCommunityStatsErr:
      'Es ist ein Fehler aufgetreten: Es konnten keine Community-Statistiken abgerufen werden.',
    communityMember: 'Community Mitglied',
    eMailaddress: 'E-Mail-Addresse (beruflich)',
    noOrganisationRegistrations: 'Keine Organisationsregistrierungen',
    areYouSureYouWantToDenyUser: 'Möchten Sie diesem Benutzer wirklich den Zugriff verweigern?',
    rejectionNotice: 'Ablehnungsnotiz',
    registrationGetFailed: 'Es ist ein Fehler aufgetreten: Konnte keine Registrierung abrufen.',
    membershipRequestAccepted: 'Mitgliedsanfrage angenommen',
    membershipRequestDenied: 'Mitgliedsanfrage abgelehnt',
    dashboard: 'Dashboard',
    users: 'Benutzer',
    getOrganisationStatsErr:
      'Es ist ein Fehler Aufgetreten: Es konnten keine Statistiken abgerufen werden.',
    domainEmptyErr: 'Bitte geben Sie eine Domäne ein',
    domainInvalidErr: 'Bitte überprüfen Sie den Domänennamen.',
    domain: 'Domäne',
    autoJoin: 'Automatisch beitreten',
    trustedDomainsOverview: 'Vertrauenswürdige Domänen',
    createTrustedDomainSuccess: 'Vertrauenswürdige Domäne wird erstellt',
    getTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Es konnte keine vertrauenswürdige Domäne abgerufen werden.',
    updateTrustedDomainSuccess: 'Vertrauenswürdige Domäne wurde aktualisiert',
    inviteNewUser: 'Neuen Benutzer einladen',
    editUser: 'Benutzer bearbeiten',
    selectRole: 'Bitte wählen Sie mindestens eine Rolle aus.',
    usernameTaken: 'Dieser Benutzername ist bereits vergeben',
    validateUsernameFailed: 'Fehler bei der Überprüfung des Benutzernamens',
    pleaseEnterAnEmailAddress: 'Bitte geben Sie eine E-mail-Adresse ein',
    pleaseEnterRecipient: 'Bitte geben Sie einen Empfänger ein',
    pleaseEnterPassword: 'Bitte Passwort eingeben',
    inviteUserSendEmailToAddress: 'Benutzer einladen, E-Mail an folgende Adresse senden:',
    createUserWithPassword: 'Benutzer mit Passwort erstellen:',
    enterPassword: 'Passwort eingeben',
    forceUserToChooseNewPassword:
      'Benutzer auffordern, bei der ersten Anmeldung ein neues Passwort zu wählen',
    inviteUser: 'Benutzer einladen',
    noUsersPresent: 'Keine Benutzer anwesend',
    areYouSureYouWantToDeleteUser: 'Möchten Sie {{userName}} entfernen?',
    delete: 'Löschen',
    deleteUser: 'Benutzer entfernen',
    getAuthorizationRolesErr:
      'Es ist ein Fehler aufgetreten: Autorisierungsrollen konnten nicht abgerufen werden.',
    userInvited: 'Benutzer eingeladen',
    inviteUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht eingeladen werden.',
    getLanguagesErr: 'Es ist ein Fehler aufgetreten: Es konnten keine Sprachen abgerufen werden.',
    getTimezonesErr: 'Es ist ein Fehler aufgetreten: Es konnte keine Zeitzone abgerufen werden.',
    userUpdated: 'Benutzer aktualisiert',
    updateUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht aktualisiert werden',
    getUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht abgerufen werden',
    userDeleted: 'Benutzer gelöscht',
    deleteUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht gelöscht werden',
    getUserStatesErr:
      'Es ist ein Fehler aufgetreten: Benutzerstatus konnte nicht abgerufen werden.',
    remove: 'Entfernen',
    addMember: 'Mitglied hinzufügen',
    apps: 'Apps',
    areYouSureYouWantToEndMembership:
      'Möchten Sie die Mitgliedschaft von {{organisationName}} wirklich beenden?',
    areYouSureYouWantToRemoveTheRequest: 'Möchten Sie die Anforderung wirklich entfernen?',
    areYouSureYouWantToendMembership:
      'Sind Sie sicher, dass Sie die Mitgliedschaft beenden möchten?',
    createTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Es konnte keine vertrauenswürdige Domäne erstellt werden.',
    endMembership: 'Mitgliedschaft kündigen',
    invite: 'Einladen',
    isHidden: 'Ist versteckt',
    isOwner: 'Ist Besitzer',
    myCommunity: 'Meine Community',
    myOrganisation: 'Meine Organisation',
    noUserPresent: 'Keine Benutzer anwesend',
    overview: 'Überblick',
    pleaseEnterEmailAddress: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    save: 'speichern',
    trustedDomains: 'Vertrauenswürdige Domäne',
    trustedDomains_plural: 'Vertrauenswürdige Domänen',
    addTrustedDomain: 'Fügen Sie eine vertrauenswürdige Domain hinzu',
    updateTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Die vertrauenswürdige Domäne konnte nicht aktualisiert werden',
    communities: 'Communities',
    home: 'Hauptmenü',
    getIdentificationCodeTypesFailed:
      'Es ist ein Fehler aufgetreten: Identifikationscodetypen konnten nicht abgerufen werden.',
    pleaseSelectAType: 'Bitte wählen Sie einen Typ',
    pleaseEnterAValue: 'Bitte einen Wert eingeben',
    disabled: 'Gesperrt',
    unverified: 'Nicht überprüft',
    verified: 'Verifiziert',
    userState: 'Benutzerstatus',
    couldNotGetCommunityTemplate:
      'Es ist ein Fehler aufgetreten, die Community-Beschreibung konnte nicht abgerufen werden',
    getTermsAndConditionsFailed:
      'Es ist ein Fehler aufgetreten, die Allgemeinen Geschäftsbedingungen konnten nicht abgerufen werden',
    chooseAPassword: 'Wähle ein Passwort',
    newPassword: 'Neues Kennwort',
    confirmPassword: 'Passwort bestätigen',
    userAccountReady: 'Benutzerkonto bereit!',
    passwordResetSuccess:
      'Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt bei Ihren Apps anmelden.',
    failedContactOur:
      'Das Passwort konnte nicht zurückgesetzt werden. Bitte wenden Sie sich an unsere',
    support: 'Servicedesk',
    department: 'Abteilung',
    pleaseConfirmUserAccount: 'Bitte bestätigen Sie, dass dies Ihr Benutzerkonto ist',
    confirm: 'Bestätigen',
    invalidToken: 'Ungültiger Token',
    needTechnicalSupport:
      'Wenn Sie technische Unterstützung benötigen, wenden Sie sich bitte an unsere',
    passwordMin8Char: 'Wählen Sie ein Passwort von mindestens 8 Zeichen',
    passwordConfirmIncorrect: 'Die Bestätigung des Passworts ist falsch',
    pleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    forgotPassword: 'Passwort vergessen',
    requestNewPassword: 'ein neues Passwort anfordern',
    resetPasswordRequested: 'Rücksetzung des Passworts angefordert!',
    resetPasswordRequestText:
      'Wenn Sie ein registrierter Benutzer sind, wurde eine E-Mail an Ihre Mailbox gesendet, um Ihr Passwort zurückzusetzen. Bitte klicken Sie auf den Link in dieser E-Mail, um fortzufahren. Sie können dieses Fenster jetzt schließen.',
    somethingWentWrong: 'Es ist ein Fehler aufgetreten.',
    pleaseContactOur: 'Bitte kontaktieren Sie unsere',
    failedResentEmail: 'Einladungs-E-Mail konnte nicht erneut gesendet werden',
    resentEmailSuccess: 'Die Einladungs-E-Mail wurde erneut gesendet',
    ohNo: 'Es ist ein Fehler aufgetreten.',
    invitationExpired: 'Ihre Einladung ist abgelaufen. Lassen Sie sich eine neue Einladung senden:',
    resentInvitationEmail: 'Einladungs-E-Mail erneut senden',
    thanksForSubscribing: 'Vielen Dank für Ihr Abonnement und willkommen auf der Plattform!',
    activatedBasicAccount:
      'Wir haben Ihr Basiskonto aktiviert, mit dem Sie auf die verschiedenen Anwendungen zugreifen können, die für Ihr Konto verfügbar sind.',
    accessApplications:
      'Sie können auf die Anträge zugreifen, sobald wir die entsprechenden unterschriebenen Vertragsformulare erhalten haben.',
    beAware:
      'Bitte beachten Sie, dass für bestimmte Anwendungen möglicherweise ein Go-Live-Datum zu einem späteren Zeitpunkt gilt.',
    contactUs: 'Kontaktiere uns',
    ifQuestions: 'Im Falle etwaiger Fragen.',
    failedToActivateUserAccount: 'Benutzerkonto konnte nicht aktiviert werden',
    goodNews: 'Gute Nachrichten!',
    accountAlreadyActivated:
      'Ihr Benutzerkonto ist bereits aktiviert. Bitte starten Sie die App über den direkten Link, wie in den App-Anweisungen angegeben.',
    invalidTokenText:
      'Ihr Aktivierungstoken ist ungültig. Stellen Sie sicher, dass Sie den Aktivierungslink in der zuletzt empfangenen Einladungs-E-Mail verwenden. Wenn Sie diese E-Mail nicht erhalten haben (vergessen Sie nicht Ihren Spam!), Können Sie sich jederzeit an unsere wenden',
    passwordInvalidErr: 'Bitte geben Sie ein gültiges Passwort ein',
    inviteSuccessMessage:
      'Ihr Benutzerkonto wurde erfolgreich auf der Nallian-Plattform registriert. Um fortzufahren und die Anwendungen zu verwenden, klicken Sie bitte auf "Weiter", um sich beim Community-Portal anzumelden.',
    address: 'Adresse',
    getOrganisationIdentificationCodesFailed:
      'Fehler beim Abrufen der Organisationsidentifikationscodes',
    getOrganisationFailed: 'Organisationsinformationen konnten nicht abgerufen werden',
    identificationCodes: 'Identifikationscodes',
    getOrganisationAddressFailed: 'Fehler beim Abrufen der Organisationsadresse',
    membershipOf: 'Mitgliedschaft bei {{organisation}}',
    organisationInfo: 'Organisationsinformationen',
    noRolesFound: 'Keine Rollen gefunden',
    noAppsFound: 'Keine Apps gefunden',
    organisationUsers: 'Benutzer',
    userReinvited: 'Benutzer nochmals eingeladen',
    userReinviteFailed: 'Benutzer konnte nicht nochmals eingeladen werden',
    reinviteUser: 'Benutzer nochmals einladen',
    areYouSureReinvite: 'Möchten sie den Benutzer {{userName}} nochmals einladen?',
    yes: 'Ja',
    no: 'Nein',
    dontHaveAnAccountYet: 'Sie haben noch kein Konto?',
    registerHere: 'Hier registrieren!',
    youHaveBeenInvited: 'Du bist eingeladen!',
    inviteInfo:
      'Jemand aus Ihrer Organisation hat Sie eingeladen, der Plattform beizutreten. Bitte bestätigen Sie, dass die unten angezeigten Details Ihnen gehören.',
    chooseAPasswordInfo: 'Bitte wählen Sie ein Passwort, um den Einladungsprozess abzuschließen.',
    resetYourPassword: 'Setze dein Passwort zurück',
    createAnotherUser: 'Erstellen Sie einen anderen Benutzer',
    createdBy: 'Erstellt von',
    createCommunityMember: 'Erstell Community-Mitglied',
    myApps: 'Meine Applikationen',
    active: 'Aktiv',
    activeState: 'Aktiver Zustand',
    activeStatus: 'Aktiver Status',
    addApplication: 'App hinzufügen',
    addAppSubscription: 'App -Abonnement hinzufügen',
    addCommunityRoleFailed: 'Das hinzufügen der Gemeinschaftrolle, ist gescheitert',
    addCommunityRoleSuccess: 'Das hinzufügen der Gemeinschaftrolle, war erfolgreich',
    addFeature: 'Function hinzufügen',
    addOwner: 'Besitzer hinzufügen',
    addRole: 'Rolle hinzufügen',
    addSubscription: 'Abonnement hinzufügen',
    addSuite: 'Suite hinzufügen',
    addTier: 'Stufe hinzufügen',
    addUser: 'Benutzer hinzufügen',
    alias: 'Alias',
    aliasEmptyErr: 'Bitte geben Sie einen Alias ​​ein',
    appDetailsAliasEmptyErr: 'Bitte geben Sie einen Alias ​​ein',
    appDetailsTagEmptyErr: 'Bitte wählen Sie eine App aus',
    appDetailsUrlEmptyErr: 'Bitte geben Sie eine URL ein',
    appFeatures: 'App -Funktionen',
    appInstallationFeatureTagEmptyErr: 'Bitte wählen Sie eine Funktion aus',
    appInstallationIdEmptyErr: 'Bitte wählen Sie eine App aus',
    appInstallations: 'App -Installationen',
    application: 'App',
    apps_plural: 'Apps',
    appSubscription: 'App -Abonnement',
    appTypeIdEmptyErr: 'Bitte wählen Sie einen App -Typ aus',
    areYouSureRemoveIdentificationCodeType:
      'Sind Sie sicher, dass Sie diesen IdentificationCode -Typ entfernen möchten?',
    areYouSureRemoveOnboardingTemplate:
      'Sind Sie sicher, dass Sie diese Onboarding -Vorlage entfernen möchten?',
    areYouSureRemovePrincipal: 'Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?',
    areYouSureRemoveRelation: 'Sind Sie sicher, dass Sie diese Beziehung entfernen möchten?',
    areYouSureYouWantToDenyJoinRequest:
      'Sind Sie sicher, dass Sie diese Join -Anfrage verweigern möchten?',
    cityEmptyErr: 'Bitte füllen Sie eine Stadt aus',
    close: 'Schließen Sie',
    community: 'Gemeinschafts',
    communityApps: 'Gemeinschafts-App',
    communityApps_plural: 'Gemeinschafts-Apps',
    communityMemberCreatedAndInvited:
      'Das Gemeinschafts -Mitglied wurde erstellt und der Benutzer wurde eingeladen',
    communityMemberCreatedAndInvitedError:
      'Das Gemeinschafts-Mitglied konnte nich erstellt und der Benutzer nicht eingeladen werden',
    communityRoles: 'Gemeinschaftsrolle',
    communityRoles_plural: 'Gemeinschaftsrollen',
    communitySuites: 'Community Suite',
    communitySuites_plural: 'Community -Suiten',
    confirmInvitationInfo:
      'Bitte bestätigen Sie, dass die untenstehenden Angaben korrekt sind. In den nächsten Schritten können Sie Ihre Kontoinformationen vervollständigen und den Registrierungsprozess abschlieSen.',
    couldNotCompleteInvitation:
      'Leider konnten wir Ihre Einladung nicht abschließen. Versuchen Sie es erneut oder wenden Sie sich an unseren Support.',
    countryEmptyErr: 'Bitte wähle ein Land',
    createAppFailed: 'Die App konnte nicht erstellt werden',
    createAppSubscriptionFailed: 'Das App -Abonnement konnte nicht erstellt werden',
    createAppSubscriptionSuccess: 'Das App -Abonnement wurde erstellt',
    createAppSuccess: 'Die App wurde erstellt',
    createCommunityAppFailed: 'Die Community -App konnte nicht erstellt werden',
    createCommunityAppSuccess: 'Die Community -App wurde erstellt',
    createCommunityMemberFailed: 'Das Community -Mitglied konnte nicht erstellt werden',
    createCommunityMemberSuccess: 'Das Community -Mitglied wurde erstellt',
    createCommunitySuiteFailed: 'Die Community Suite konnte nicht erstellt werden',
    createCommunitySuiteSuccess: 'Die Community Suite wurde erstellt',
    createIdentificationCodeTypeFailed: 'Den IdentificationCode -Typ konnte nicht erstellt werden',
    createIdentificationCodeTypeSuccess: 'Der IdentificationCode -Typ wurde erstellt',
    createNewMember: 'Neues Mitglied erstellen',
    createNewOrganisation: 'Neue Organisation erstellen',
    createOnboardingTemplateFailed: 'Die Onboarding -Vorlage konnte nicht erstellt werden',
    createOnboardingTemplateSuccess: 'Die Onboarding -Vorlage wurde erstellt',
    createOrganisationRoleFailed: 'Die Organisationsrolle konnte nicht erstellt werden',
    createOrganisationRoleSuccess: 'Die Organisationsrolle wurde erstellt',
    createPrincipalFailed: 'Der Benutzer konnte nicht erstellt werden',
    createPrincipalSuccess: 'Der Benutzer wurde erstellt',
    createRelationFailed: 'Die Beziehung konnte nicht erstellt werden',
    createRelationSuccess: 'Die Beziehung wurde erstellt',
    createRelationTypeFailed: 'Der Beziehungstyp konnte nicht erstellt werden',
    createRelationTypeSuccess: 'Der Beziehungstyp wurde erstellt',
    createSuiteFailed: 'Der Benutzer konnte nicht erstellt werden',
    createSuiteSuccess: 'Die Suite wurde erstellt',
    createUserFailed: 'Der Benutzer konnte nicht erstellt werden',
    createUserSuccess: 'Der Benutzer wurde erstellt',
    defaultCommunity: 'Standardgemeinschaft',
    deleted: 'Gelöscht',
    denyJoinRequestFailed: 'Die Beitritts -Anfrage konnte nicht abgelehnt werden',
    denyJoinRequestSuccess: 'Die Beitritts -Anfrage wurde abgelehnt',
    descriptionEmptyErr: 'Bitte geben Sie eine Beschreibung ein',
    details: 'Einzelheiten',
    displayName: 'Name anzeigen',
    editApp: 'App bearbeiten',
    editCommunityApp: 'Community -App bearbeiten',
    editCommunityMember: 'Community -Mitglied bearbeiten',
    editCommunityRole: 'Community -Rolle bearbeiten',
    editFeature: 'Function bearbeiten',
    editOrganisationRole: 'Organisationsrolle bearbeiten',
    editSubscription: 'Abonnement bearbeiten',
    email: 'E-Mail Addresse',
    emailAddress: 'E-Mail Addresse',
    emailAddressEmptyErr: 'Bitte geben Sie eine E-Mail-Adresse ein',
    emailOrPhoneNumberRequiredError:
      'Eine gültige E -Mail -Adresse oder Handynummer ist erforderlich',
    externalIdentifier: 'Externe Kennung',
    feature: 'Merkmal',
    features: 'Merkmale',
    featureSubscriptions: 'Abonnements',
    firstSelectAFeature: 'Wählen Sie zuerst eine Funktion',
    firstSelectAnApp: 'Wählen Sie zuerst eine App',
    fullNameEmptyErr: 'Bitte geben Sie einen vollständigen Namen ein',
    general: 'Allgemein',
    getAppFailed: 'Die App konnte nicht geladen werden',
    getAppInstallationFailed: 'Kann die App -Installation nicht abrufen',
    getAppInstallationsFailed: 'Kann die App -Installationen nicht abrufen',
    getAppsFailed: 'Kann die Apps nicht abrufen',
    getAppSubscriptionsFailed: 'Kann die App -Abonnements nicht abrufen',
    getAvailableRolesFailed: 'Kann die verfügbaren Rollen nicht abrufen',
    getCommunityAppsFailed: 'Kann die Community -Apps nicht abrufen',
    getCommunityMemberRolesFailed:
      'Kann die verfügbaren Rollen für diese Organisation nicht abrufen',
    getIdentificationCodeTypeFailed: 'Kann den Identifikationstyp nicht abrufen',
    getJoinRequestFailed: 'Kann die Join -Anfrage nicht abrufen',
    getOnboardingTemplateFailed: 'Kann die Onboarding -Vorlage nicht abrufen',
    getOrganisationRolesFailed: 'Kann die Rollen nicht abrufen',
    getPrincipalFailed: 'Kann den Benutzer nicht abrufen',
    getRelationFailed: 'Kann die Beziehung nicht abrufen',
    getRelationsFailed: 'Kann die Beziehungen nicht abrufen',
    getRelationTypeFailed: 'Kann den Beziehungstyp nicht abrufen',
    getRelationTypesFailed: 'Kann die Beziehungstypen nicht abrufen',
    getSuiteFailed: 'Kann die Suite nicht abrufen',
    getSuitesFailed: 'Kann die Suiten nicht abrufen',
    global: 'Global',
    here: 'Hier',
    hostedAt: 'Gehosted bei',
    identificationcodetypes: 'IdentificationCode -Typ',
    identificationcodetypes_plural: 'IdentificationCode -Typen',
    identities: 'Konten',
    identity: 'Konto',
    inactive: 'Inaktiv',
    installationIndex: 'Installations-Index',
    introducedInVersion: 'In der Version eingeführt',
    introducedInVersionEmptyErr:
      'Bitte geben Sie an, in welcher Version die Function eingefürt wurde',
    invalidInvitation1: 'Beim Erhalt Ihrer Einladung ist etwas schief gelaufen.',
    invalidInvitation2: 'Sie ist möglicherweise abgelaufen oder existiert nicht',
    invitationExpiresOn: 'Einladung läuft ab am',
    invitationInfo:
      '<bold>{{username}}</bold> von Organisation <bold>{{organisation}}</bold> hat Sie eingeladen, der <bold>{{community}}</bold> Community beizutreten.',
    invitationSentOn: 'Einladung gesendet am',
    invitationState: 'Status der Einladung',
    invitationType: 'Einladungs-Typ',
    invited: 'Eingeladen',
    inviteFreeText:
      'Fügen Sie eine Nachricht hinzu, die in die Einladungs-E-Mail enthalten sein wird',
    isCustomer: 'Ist Kunde',
    isGloballyManaged: 'Wird global verwaltet',
    isOptional: 'Ist optional',
    isSystem: 'Ist System',
    isVisible: 'Ist sichtbar',
    joinMessage: 'Ihre Nachricht an den Community -Administrator',
    joinRequestAcceptedInfo:
      'Sehr geehrte(r) {{fullName}}, Ihre Beitritts -Anfrage wurde genehmigt.',
    joinRequestError: 'Beitritts -Anfrage konnte nicht gesendet werden',
    joinRequestErrorMessage:
      'Beim Senden Ihre Beitritts -Anfrage an den Community -Administrator ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal',
    joinRequests: 'Beitrittsanträge',
    joinRequestSentToCommunityAdmin: 'Beitrittsanfrage an die Community-Administration gesendet',
    joinRequestSentToCommunityAdminDescription:
      'Ihre Beitritts -Anfrage wurde an die Community -Administration gesendet, um Ihnen den Zugriff auf Community -Apps zu gewähren.',
    languageEmptyErr: 'Bitte wählen Sie eine Sprache',
    languageIdEmptyErr: 'Bitte wählen Sie eine Sprache',
    linkExistingOrganisation: 'Verbinden Sie die vorhandene Organisation',
    linkIdentityFailed: 'Konto konnte nicht mit Benutzer verknüpft werden',
    linkIdentitySuccess: 'Mit dem Benutzer verknüpftes Konto',
    linkMyIdentityToPrincipal: 'Mein Konto mit dem Benutzer verknüpfen',
    location: 'Standort',
    lockedOut: 'Ausgesperrt',
    management: 'Verwaltung',
    mine: '(meine Konto)',
    newApp: 'Neue App',
    newAppSubscription: 'Neues App -Abonnement',
    newCommunityApp: 'Neue Community -App',
    newCommunityMember: 'Neues Community -Mitglied',
    newCommunityRole: 'Neue Gemeinschaftsrolle',
    newCommunitySuite: 'Neue Community Suite',
    newFeature: 'Neue Funktion',
    newIdentificationCodeType: 'Typ hinzufügen',
    newOnboardingTemplate: 'Neue Onboarding -Vorlage',
    newOrganisationRole: 'Neue Organisationsrolle',
    newRelation: 'Neue Beziehung',
    newRelationType: 'Neue Beziehungsart',
    newSuite: 'Neue Suite',
    newUser: 'Neuer Benutzer',
    noAppsConfiguredForOnboardingTemplate: 'Keine Apps für die Vorlage konfiguriert.',
    noFeaturesDefined: 'Keine Funktionen definiert',
    noFeaturesDefinedYet: 'Noch keine Funktionen konfiguriert',
    noFeaturesFound: 'Keine Funktionen gefunden',
    noLinkedAccountsYet: 'Noch keine verknüpften Konten.',
    noPendingInvitationsFound: 'Keine ausstehenden Einladungen gefunden',
    noRolesDefined: 'Keine Rollen definiert',
    noSuitesFound: 'Keine Suiten gefunden',
    noTiersFound: 'Keine Tiers gefunden',
    noUsersFound: 'Keine Benutzer gefunden',
    noValidPeriod: 'Automatisch abonniert',
    organisationCityEmptyErr: 'Bitte geben Sie eine Stadt ein',
    organisationCountryEmptyErr: 'Bitte geben Sie ein Land ein',
    organisationDetailsDescription: 'Füllen Sie die Details der Organisation ein',
    organisationNameEmptyErr: 'Bitte geben Sie einen Organisationsnamen ein',
    organisationRole: 'Rolle der Organisation',
    organisationRoles: 'Rolle der Organisation',
    organisationRoles_plural: 'Rollen der Organisation',
    organisations: 'Organisationen',
    organisationsOverview: 'Übersicht der Organisationen',
    owners: 'Eigentümer',
    parentOrganisation: 'Überordnete Organisation',
    passwordToDelete: 'Passwort zum Löschen',
    pending: 'Ausstehend',
    pendingInvitations: 'Ausstehende Einladung',
    pendingInvitations_plural: 'Ausstehende Einladungen',
    phoneNumber: 'Handynummer',
    pleaseAcceptOurTermsAndConditions:
      'Bitte akzeptieren Sie unsere Allgemeinen Geschäftsbedingungen',
    pleaseCompleteOrganisationDetails:
      'Bitte vervollständigen Sie die Details Ihrer Organisation unten.',
    postalCodeEmptyErr: 'Bitte geben Sie eine Postleitzahl ein',
    primaryEmailAddressEmptyErr: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    primaryPhoneNumberEmptyErr: 'Bitte geben Sie eine gültige Handynummer ein',
    principalFullNameEmptyErr: 'Bitte geben Sie einen vollständigen Namen ein',
    principalLanguageIdEmptyErr: 'Bitte wählen Sie eine Sprache',
    principals: 'Benutzer',
    principalTimeZoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    reInvite: 'Neu einladen',
    relationType: 'Beziehung',
    relationTypeIdEmptyErr: 'Bitte wählen Sie einen Beziehungstyp',
    relationTypes: 'Beziehungstyp',
    relationTypes_plural: 'Beziehungstypen',
    removeApp: 'App entfernen',
    removeAppAndRoles: 'App, Funktionen und Rollen entfernen',
    removeAppSubscriptionFailed: 'Abonnement entfernen fehlgeschlagen',
    removeAppSubscriptionSuccess: 'Abonnement entfernen erfolgreich',
    removeFeature: 'Merkmal entfernen',
    removeThisFeature: 'Entfernen Sie diese Funktion',
    removeThisRole: 'Rolle entfernen',
    removeThisSuite: 'Entfernen Sie diese Suite',
    removeThisTier: 'Entfernen Sie diese Stufe',
    requestToJoin: 'Anfrage zum Beitritt',
    requestToJoinInfo:
      'Wenn Ihre Organisation dieser Community beitreten möchte, füllen Sie bitte das Formular aus. <br/> Der Community -Administrator überprüft Ihre Bewerbung und kontaktiert Sie in Kürze.',
    requiresSubscription: 'Abonnement erfordern',
    resendInvitationFailed: 'Die Einladung konnte nicht nochmal gesendet werden',
    resendInvitationSuccess: 'Die Einladung wurde nochmal gesendet',
    resetPassword: 'Passwort zurücksetzen',
    reviewJoinRequest: 'Überprüfung der Join -Anfrage',
    selectAnApp: 'Bitte wählen Sie eine App',
    selectAnApplication: 'Bitte wählen Sie eine App',
    sendInvitation: 'Bitte Einladung senden',
    sometingWentWrong: 'Etwas ist schief gelaufen',
    source: 'Quelle',
    sourceIdEmptyErr: 'Bitte wählen Sie eine Quelle',
    sourceOrganisationRoles: 'Quelle organisationsrollen',
    stateName: 'Zustand',
    status: 'Status',
    streetAndNumberEmptyErr: 'Bitte füllen Sie eine Straße und eine Nummer aus',
    tag: 'Etikett',
    tagEmptyErr: 'Bitte füllen Sie ein Etikett aus',
    tagExplainer: 'Beginnt mit alphabetischen Charakter, maximaler Länge von 20',
    target: 'Ziel',
    targetIdEmptyErr: 'Bitte wählen Sie ein Ziel',
    targetOrganisationRoles: 'Ziel Organisationsrollen',
    template: 'Vorlage',
    templateHasNoConfiguration: 'Vorlage hat keine Konfiguration',
    templateInfo1:
      'Eine Vorlage gibt den Administrator zugriff auf eine Reihe von Apps und eine Liste von Organisationsrollen.',
    templateInfo2: 'Wählen Sie eine Vorlage aus, um ihre Konfiguration anzuzeigen',
    textMessage: 'Textnachricht',
    timezoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    timeZoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    timeZoneIdEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    unauthorized: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
    unlink: 'Abtrennen',
    unlinkIdentityFailed: 'Die Verknüpfung des Kontos konnte nicht aufgehoben werden',
    unlinkIdentitySuccess: 'Die Verknüpfung des Kontos wurde aufgehoben',
    unlisted: 'Nicht gelistet',
    updateAppFailed: 'Die App konnte nicht aktualisiert werden',
    updateAppSubscriptionFailed: 'Das App -Abonnement konnte nicht aktualisiert werden',
    updateAppSubscriptionSuccess: 'Das App -Abonnement wurde aktualisiert',
    updateAppSuccess: 'Die App wurde aktualisiert',
    updateCommunityAppFailed: 'Die Community -App konnte nicht aktualisiert werden',
    updateCommunityAppSuccess: 'Die Community -App wurde aktualisiert',
    updateCommunityMemberFailed: 'Das Community -Mitglied konnte nicht aktualisiert werden',
    updateCommunityMemberRolesFailed:
      'Die Rollen der Community -Mitglieder konnte nicht aktualisiert werden',
    updateCommunityMemberRolesSuccess: 'Die Rollen der Community -Mitglieder wurden aktualisiert',
    updateCommunityMemberSuccess: 'Das Community -Mitglied wurde aktualisiert',
    updateCommunityRoleFailed: 'Die Community -Rolle konnte nicht aktualisiert werden',
    updateCommunityRoleSuccess: 'Die Community -Rolle wurde aktualisiert',
    updateCommunitySuiteFailed: 'Die Community Suite konnte nicht aktualisiert werden',
    updateCommunitySuiteSuccess: 'Die Community Suite wurde aktualisiert',
    updateIdentificationCodeTypeFailed:
      'Den IdentificationCode -Typ konnte nicht aktualisiert werden',
    updateIdentificationCodeTypeSuccess: 'Der EidentificationCode -Typ wurde aktualisiert',
    updateOnboardingTemplateFailed: 'Die Onboarding -Vorlage konnte nicht aktualisiert werden',
    updateOnboardingTemplateSuccess: 'Die Onboarding -Vorlage wurde aktualisiert',
    updateOrganisationRoleFailed: 'Die Organisationsrolle konnte nicht aktualisiert werden',
    updateOrganisationRoleSuccess: 'Die Organisationsrolle wurde aktualisiert',
    updatePrincipalFailed: 'Der Benutzer konnte nicht aktualisiert werden',
    updatePrincipalSuccess: 'Der Benutzer wurde aktualisiert',
    updateRelationFailed: 'Die Beziehung konnte nicht aktualisiert werden',
    updateRelationSuccess: 'Die Beziehung wurde aktualisiert',
    updateRelationTypeFailed: 'Den Beziehungstyp konnte nicht aktualisiert werden',
    updateRelationTypeSuccess: 'Der Beziehungstyp wurde aktualisiert',
    updateUserSuccess: 'Der Benutzer wurde aktualisiert',
    url: 'URL',
    urlEmptyErr: 'Bitte geben Sie eine URL ein',
    useATemplate: 'Bitte verwenden Sie eine Vorlage',
    user: 'Benutzer',
    userDetailsDescription: 'Bitte füllen Sie die Benutzerdetails aus',
    validationPattern: 'Validierungsmuster',
    validFrom: 'Gültig ab',
    validPeriod: 'Gültigkeitsdauer',
    validUntil: 'Gültig bis',
    verifiedStatus: 'Überprüter Status',
    view: 'Sicht',
    viewSubscribedOrganisations: 'Abonnierte Organisationen anzeigen',
    viewTemplate: 'Vorlage anzeigen',
    welcomeToThePlatform: 'Willkommen auf der Plattform!',
    welcomeToThePlatformInfo:
      'Ihr Benutzerkonto wurde erfolgreich auf der Nallian -Plattform registriert. Um fortzusetzen und die Anwendungen zu verwenden, klicken Sie bitte auf "fortfahren", um sich beim Nallian -Portal anzumelden.',
    appSubscriptions: 'App -Abonnementen',
    description: 'Beschreibung',
    createdByOrganisation: 'Erstellt von Organisation',
    metaData: 'Metadaten',
    lastModifiedOn: 'Zuletzt geändert am',
    linkedAccounts: 'Verbundene Konten',
    relations: 'Beziehungen',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Möchten Sie das Abonnement für diese Funktion wirklich entfernen? Der Zugriff auf diese Funktion wird allen Benutzern dieser Organisation entzogen.',
    applyOnboardingTemplate: 'Onboarding-Vorlage anwenden',
    getOnboardingTemplatesFailed: 'Onboarding-Vorlagen konnten nicht abgerufen werden',
    selectAnOnboardingTemplate: 'Wählen Sie eine Onboarding-Vorlage aus',
    onboardingTemplateIdEmptyErr: 'Bitte wählen Sie eine Onboarding-Vorlage aus',
    applyOnboardingTemplateFailed: 'Onboarding-Vorlage konnte nicht angewendet werden',
    applyOnboardingTemplateSuccess: 'Onboarding-Vorlage angewendet',
    addTemplateInfo:
      'Die Vorlage fügt der Organisation die folgenden Apps und Community-Rollen hinzu',
    filters: 'Filter',
    filterOnUserRole: 'Filtern Sie nach Benutzerrolle',
    identityOrClient: 'Konto oder client',
    searchForAnIdentityOrAddClientId:
      'Suchen Sie nach einer Konto oder fügen Sie eine Kunden-ID hinzu',
    filterOnIdentificationCode: 'Filter on identification code',
    useNoTemplate: 'Verwenden Sie keine Vorlage',
    templateInfo: 'Wählen Sie eine Vorlage aus',
    userInfo: 'Benutzerinformation',

    invalidUrlCommuntiyAppFeature:
      'Muss eine gültige URL sein oder muss [Environmenturl] enthalten',
    communitiesOverview: 'Gemeinschaftenübersicht',
    createCommunityFailed: 'Konnte keine Gemeinschaft schaffen',
    createCommunitySuccess: 'Gemeinschaft geschaffen',
    newCommunity: 'Neue Gemeinschaft',
    themeName: 'Theme name',
    defaultLanguage: 'Standardsprache',
    mustBeValidUrl: 'Muss eine gültige URL sein',
    updateCommunityFailed: 'Konnte die Gemeinschaft nicht aktualisieren',
    updateCommunitySuccess: 'Gemeinschaft aktualisiert',
    fixedCommunityId:
      'ID (nicht obligatorisch, nur wenn Sie dieselbe Gemeinschaft -ID in allen Umgebungen wünschen)',
    updateNotificationSettingsFailed:
      'Es konnte keine Benachrichtigungseinstellungen aktualisieren',
    updateNotificationSettingsSuccess: 'Benachrichtigungseinstellungen aktualisiert',
    notificationSettings: 'Benachrichtigungseinstellungen',
    fromName: 'Von Namen',
    fromEmail: 'Aus der Email',
    replyToEmail: 'Antwort auf E -Mail',
    replyToName: 'Antwort auf den Namen',
    emailSubjectPrefix: 'E -Mail -Betreff Präfix',
    contactEmail: 'Kontakt E-mail',
    updateHostsFailed: 'Konnte Hosts nicht aktualisieren',
    updateHostsSuccess: 'Hosts aktualisiert',
    noHostsYet: 'Host hinzufügen',
    addHost: 'Host erstellen',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Ist primär',
    onlyOnePrimaryHost: 'Nur ein Host kann primär sein',
    minOnePrimaryHost: 'Mindestens ein Wirt muss primär sein',
    pleaseEnterAHost: 'Bitte geben Sie einen (gültigen) Host ein',
    tenantId: 'Tenant ID',
    tenantHostUrl: 'Tenant host url',
    tenantInformation: 'Tenant information',
    // theme lookups (internal)
    themeLookups_plural: 'Theme lookups',
    newThemeLookup: 'New theme lookup',
    title: 'Title',
    createThemeLookupFailed: "Couldn't create theme lookup",
    createThemeLookupSuccess: 'Theme lookup created',
    updateThemeLookupFailed: "Couldn't update theme lookup",
    updateThemeLookupSuccess: 'Theme lookup updated',
    editThemeLookup: 'Edit theme lookup',
    themeLookups: 'Theme lookup',
    titleEmptyErr: 'Please enter a title',
    hostEmptyErr: 'Please enter a host',
    themeNameEmptyErr: 'Please enter a theme name',
    editCommunityTextFailed: "Couldn't update community text",
    editCommunityTextSuccess: 'Community text updated',
    documentUploaded: 'Document uploaded',
    documentUploadFailed: 'Document upload failed',
    noCommunityTextYet: 'No community welcome text yet',
    noDocumentsYet: 'No documents yet',
    addLanguage: 'Add language',
    enterLanguageKey: 'Enter your language key',
    emailNotificationFooter: 'Email notification footer',
    emailNotificationHeader: 'Email notification header',
    blobsUpdated: 'Blobs updated',
    blobsNotUpdated: 'Failed to update blobs',
    removeCommunityAppClientFailed: "Couldn't remove client",
    removeCommunityAppClientSuccess: 'Client removed',
    createCommunityAppClientFailed: "Couldn't create client",
    createCommunityAppClientSuccess: 'Client created',
    getCommunityAppClientsFailed: "Couldn't get clients",
    manageClientsForCommunityApp: 'Manage clients',
    addClient: 'Add client',
    manageAppClients: 'Manage app clients',
    noClientsYet: 'No clients yet',
    unknownIdentityProvider: 'Unbekannter Identitätsanbieter',
    areYouSureRemoveOrganisation:
      'Sind Sie sicher, dass Sie die Organisation "{{item.name}}" entfernen möchten?',
    timeSettings: 'Zeit Einstellungen',
    userDetails: 'Benutzer Details',
    appsAndRoles: 'Apps und Rollen',
    accountsIdentities: 'Verbundene Konten',
    accounts: 'Konten',
    areYouSureContinueWithoutUserHasRoles:
      'Sind Sie sicher, dass Sie diesem Benutzer keinen Zugriff auf eine Anwendung gewähren möchten?',
    principalRemoved: 'Benutzer entfernt',
    userGroups: 'Benutzergruppen',
    selectUserGroups: 'Wählen Sie Benutzergruppen aus',
    data: 'Daten',
    id: 'ID',
    shortName: 'Kurzer Namen',
    installations: 'Installationen',
    isGlobal: 'Ist global',
    isCrossCommunity: 'Ist gemeinschaftsübergreifend',
    isObsolete: 'Ist obsolet',
    copyToClipboard: 'In die Zwischenablage kopieren',
    administrators: 'Administratoren',
    welcomeText: 'Begrüßungstext der Community',
    overviewText: 'Übersichtstext der Homepage',
    pleaseTypeToEnableConfirmButton:
      "Bitte geben Sie '{{message}}' ein, um die Bestätigungsschaltfläche zu aktivieren.",
    pleaseTypeHere: 'Bitte hier eintragen',
    removeOrganisation: 'Organisation entfernen',
    removeOrganisationFailed: 'Organisation konnte nicht entfernt werden',
    removeOrganisationSuccess: 'Organisation entfernt',
    removeAppInstallation: 'App-Installation entfernen',
    areYouSureRemoveAppInstallation:
      'Möchten Sie die App-Installation wirklich entfernen "{{item.name}}"?',
    removeAppInstallationFailed: 'App-Installation konnte nicht entfernt werden',
    removeAppInstallationSuccess: 'App-Installation entfernt',
    noRoles: 'No roles',
    rolesCount: '{{count}} role(s)',
    noIdentificationCodeTypesFound: 'Keine Identifikationscodetypen gefunden',
    isRequired: 'Ist erforderlich',
    identificationCodeTypeTagEmptyErr: 'Bitte wählen Sie einen Identifikationscodetyp',
    editType: 'Typ bearbeiten',
    theFollowingIdentificationCodeTypesAreRequired:
      'Folgende Identifikationscodes fehlen: {{missingTypes}}',
    updateContactFailed: 'Kontakt konnte nicht aktualisiert werden',
    updateContactSuccess: 'Kontakt aktualisiert',
    createContactFailed: 'Kontakt konnte nicht erstellt werden',
    createContactSuccess: 'Kontakt erstellt',
    removeContactFailed: 'Kontakt konnte nicht entfernt werden',
    removeContactSuccess: 'Kontakt entfernt',
    contacts: 'Kontakte',
    noContactsYet: 'Noch keine Kontakte.',
    newContact: 'Neuer Kontakt',
    editContact: 'Kontakt bearbeiten',
    areYouSureYouWantToRemoveContact: 'Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?',
    logo: 'Logo',
    uploadANewLogo: 'Neues Logo hochladen',
    noLogoAvailable: 'Noch kein Logo vorhanden.',
    viewLogo: 'Logo anzeigen',
    uploadLogo: 'Logo hochladen',
    removeOrganisationLogoFailed: 'Logo konnte nicht entfernt werden',
    removeOrganisationLogoSuccess: 'Logo entfernt',
    uploadLogoSuccess: 'Logo hochgeladen',
    uploadLogoError: 'Logo konnte nicht hochgeladen werden',
    removeLogo: 'Logo entfernen',
    areYouSureYouWantToRemoveLogo: 'Sind Sie sicher, dass Sie das Logo entfernen möchten?',
    fileEmptyErr: 'Bitte laden Sie eine gültige Datei hoch',
    pleaseSelectRoles: 'Bitte wählen Sie Rollen aus',
  },
};
